<template>
    <div class="box">
        <!--    <top></top>-->
        <div class="details" v-if="!loading && !timeout">
            <div class="detail-top">
                <h1 v-html="title">{{ title }}</h1>
            </div>
            <div class="detail-content">
                <p class="common author"><span>作者:</span> {{ author }}</p>
                <p class="common unit">
                    <span>作者地址:</span>
                    <font v-for="item in auAff" v-bind:key="item">{{ item }}</font>
                </p>
                <p class="common"><span>出处:</span>{{ source }}</p>
                <p class="common"><span>刊号:</span>{{ issn }}</p>
                <p class="common unit">
                    <span style="width:2.3rem">摘要:</span>
                    {{ ab }}
                </p>
            </div>
            <!-- <div class="detail-operation">
               <md-button  @click="showPopUp('bottom')">
                 <div class="view-apply">
                   <img src="../../assets/img/file.png" alt="">
                   <span>下载PDF</span>
                 </div>
               </md-button>
             </div>-->
        </div>
        <!--loading-->
        <md-skeleton title :loading="loading"></md-skeleton>
        <md-skeleton title :loading="loading" class="mt40"></md-skeleton>
        <md-skeleton title :loading="loading" class="mt40"></md-skeleton>
        <div class="tip" v-show="timeout">请求超时,点击<span @click="getDetail">重新请求</span></div>
    </div>
</template>

<script>
//import top from '../components/header'
import { Icon, Button, ActivityIndicator, Skeleton, Toast, Popup, PopupTitleBar, InputItem, Field } from "mand-mobile";

export default {
    name: "detail",
    data() {
        return {
            ab: "", //摘要
            auAff: "", //作者单位
            author: "", //作者
            source: "", //出处
            issn: "", //刊号
            title: "", //标题
            loading: true,
            isPopupShow: {},
            email: "",
            pmid: "",
            timeout: false
        };
    },
    components: {
        //  top,
        [Icon.name]: Icon,
        [Button.name]: Button,
        [ActivityIndicator.name]: ActivityIndicator,
        [Skeleton.name]: Skeleton,
        [Toast.component.name]: Toast.component,
        [Popup.name]: Popup,
        [PopupTitleBar.name]: PopupTitleBar,
        [InputItem.name]: InputItem,
        [Field.name]: Field
    },
    mounted: function() {
        this.getDetail();
    },
    methods: {
        getDetail: function() {
            this.loading = true;
            this.timeout = false;
            let link = this.$route.query.link;
            this.timeout = false;
            // api.wosDetail(encodeURIComponent(link)).then((res)=>{
            this.$get("/wos/detail?url=" + encodeURIComponent(link)).then((res) => {
                if (res.code === 0) {
                    this.loading = false;
                    this.ab = res.data.ab;
                    this.auAff = res.data.address;
                    this.author = res.data.au;
                    this.source = res.data.so;
                    this.issn = res.data.issue;
                    this.title = res.data.ti;
                }
            }) /*
          .catch(error => {
            if (error.response) {
            } else if (error.request) {
              if (error.request.readyState == 4 && error.request.status == 0) {
                this.loading = false;
                this.dataNull = false;
                this.timeout = true;
              }
              else {
                this.loading = false;
                this.dataNull = true;
                this.timeout = false;
              }
            } else {
              this.loading = false;
              this.dataNull = true;
              this.timeout = false;
            }
          })*/;
        },
        showPopUp() {},
        hidePopUp(type, guanbi) {
            /*let params = {
       ctype: 2,
       url: encodeURIComponent(this.url),
       title: this.title,
       author: this.author,
       source: this.source,
       email: this.email,
     };*/
            if (guanbi !== "guanbi") {
                if (this.isPopupShow.bottom) {
                    /* let url = '';
                    if(this.pmid){ //this.url
                        url='https://zsytbk.9itsg.net/user/fulltext-apply.do?url='
                        + encodeURIComponent(this.url) + '&ctype=0&pmid='+this.pmid+'&title='
                        + this.title + '&author=' + this.author + '&source=' + this.source + '&email=' + this.email
                    }
                    else{
                        url='https://zsytbk.9itsg.net/user/fulltext-apply.do?ctype=1&title=' + this.title + '&author=' + this.author + '&source=' + this.source +
                        '&email=' + this.email+'&ut='
                    }*/
                    Toast.loading("申请中...");
                    // api.fulltextApplyDo('https://zsytbk.9itsg.net/user/fulltext-apply.do?url=' + encodeURIComponent(this.url) + '&ctype=2&title=' + this.title + '&author=' + this.author + '&source=' + this.source + '&email=' + this.email,'').then((res)=>{
                    this.$get(
                        "https://zsytbk.9itsg.net/user/fulltext-apply.do?url=" +
                            encodeURIComponent(this.url) +
                            "&ctype=2&title=" +
                            this.title +
                            "&author=" +
                            this.author +
                            "&source=" +
                            this.source +
                            "&email=" +
                            this.email
                    )
                        .then((res) => {
                            if (res.code === 0) {
                                Toast.loading("申请成功");
                                setTimeout(() => {
                                    Toast.hide();
                                }, 2200);
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            }
            this.$set(this.isPopupShow, type, false);
        }
    }
};
</script>

<style scoped>
.box {
    padding: 10px;
}

.details {
    width: 100%;
    margin-top: 10px;
    display: table;
}

.detail-top {
    display: table;
    width: 100%;
    padding-bottom: 24px;
    border-bottom: 0.005rem solid #e5e5e5; /*no*/
}

.detail-top h1 {
    font-size: 24px;
    color: #2d5459;
}

.detail-top p {
    margin-top: 15px;
    font-size: 16px;
    line-height: 50px;
    color: #929292;
}

.common {
    margin-top: 10px;
    font-size: 16px;
    display: table;
    width: 100%;
}

.common span {
    font-weight: bold;
    color: black;
    margin-right: 24px;
}

.common font {
    display: block;
    width: 100%;
    margin-top: 5px;
}

.common a {
    margin-right: 25px;
    text-decoration: underline;
    color: #9b9b9b;
}

.unit {
    line-height: 30px;
}

.detail-operation {
    width: 100%;
    margin-top: 100px;
    display: table;
}

.detail-operation button {
    background-color: #305359;
    width: 45% !important;
    height: 50px;
    margin: 0 auto;
}

.detail-operation span {
    color: white;
}

.fl {
    float: left;
}

.fr {
    float: right;
}

.view-apply {
    width: auto;
    margin: 0 auto;
    height: 100%;
    display: table;
}

.view-apply img {
    height: 30px;
    float: left;
    margin-right: 10px;
    margin-top: 35px;
}

.view-apply span {
    float: right;
    display: block;
    font-size: 16px;
}

#loading {
    margin-top: 130px;
}

.mt150 {
    margin-top: 150px !important;
}

.mt40 {
    margin-top: 40px !important;
}

.tip {
    margin-top: 200px;
    text-align: center;
    font-size: 30px;
}

.tip span {
    text-decoration: underline;
    color: #305359;
}
</style>
